// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://snowscan.xyz/address/0xa97684ead0e402dC232d5A977953DF7ECBaB3CDb
export const POOL_ADDRESSES_PROVIDER = '0xa97684ead0e402dC232d5A977953DF7ECBaB3CDb';

// IPool https://snowscan.xyz/address/0x794a61358D6845594F94dc1DB02A252b5b4814aD
export const POOL = '0x794a61358D6845594F94dc1DB02A252b5b4814aD';

// IPoolConfigurator https://snowscan.xyz/address/0x8145eddDf43f50276641b55bd3AD95944510021E
export const POOL_CONFIGURATOR = '0x8145eddDf43f50276641b55bd3AD95944510021E';

// IAaveOracle https://snowscan.xyz/address/0xEBd36016B3eD09D4693Ed4251c67Bd858c3c7C9C
export const ORACLE = '0xEBd36016B3eD09D4693Ed4251c67Bd858c3c7C9C';

// https://snowscan.xyz/address/0x3C06dce358add17aAf230f2234bCCC4afd50d090
export const ACL_ADMIN = '0x3C06dce358add17aAf230f2234bCCC4afd50d090';

// IACLManager https://snowscan.xyz/address/0xa72636CbcAa8F5FF95B2cc47F3CDEe83F3294a0B
export const ACL_MANAGER = '0xa72636CbcAa8F5FF95B2cc47F3CDEe83F3294a0B';

// IPoolDataProvider https://snowscan.xyz/address/0x243Aa95cAC2a25651eda86e80bEe66114413c43b
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x243Aa95cAC2a25651eda86e80bEe66114413c43b';

// https://snowscan.xyz/address/0x81af89Ff37bd5ece022139B833F4efabf62E8eEc
export const POOL_IMPL = '0x81af89Ff37bd5ece022139B833F4efabf62E8eEc';

// https://snowscan.xyz/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://snowscan.xyz/address/0x929EC64c34a17401F460460D4B9390518E5B473e
export const DEFAULT_INCENTIVES_CONTROLLER = '0x929EC64c34a17401F460460D4B9390518E5B473e';

// https://snowscan.xyz/address/0x048f2228D7Bf6776f99aB50cB1b1eaB4D1d4cA73
export const EMISSION_MANAGER = '0x048f2228D7Bf6776f99aB50cB1b1eaB4D1d4cA73';

// ICollector https://snowscan.xyz/address/0x5ba7fd868c40c16f7aDfAe6CF87121E13FC2F7a0
export const COLLECTOR = '0x5ba7fd868c40c16f7aDfAe6CF87121E13FC2F7a0';

// https://snowscan.xyz/address/0x88ee4632d8f7fAC47Ebbeb63c4C2875d0974B8B4
export const DEFAULT_A_TOKEN_IMPL = '0x88ee4632d8f7fAC47Ebbeb63c4C2875d0974B8B4';

// https://snowscan.xyz/address/0xC0442C25FE517ac37D6a0D485446307D97d24712
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0xC0442C25FE517ac37D6a0D485446307D97d24712';

// https://snowscan.xyz/address/0x23AceD103f5E22bD22B9272c82f29C0E51abC5c2
export const RISK_STEWARD = '0x23AceD103f5E22bD22B9272c82f29C0E51abC5c2';

// https://snowscan.xyz/address/0x57218F3aB422A39115951c3Eb06881a7A719DfdD
export const EDGE_RISK_STEWARD_CAPS = '0x57218F3aB422A39115951c3Eb06881a7A719DfdD';

// https://snowscan.xyz/address/0x54714FAc85b0bf627288CC3a186dE81A42f1D635
export const EDGE_INJECTOR_CAPS = '0x54714FAc85b0bf627288CC3a186dE81A42f1D635';

// https://snowscan.xyz/address/0x1273f29204fC102bD4620485B13cFE27a794fF32
export const EDGE_RISK_ORACLE = '0x1273f29204fC102bD4620485B13cFE27a794fF32';

// https://snowscan.xyz/address/0xE28E2c8d240dd5eBd0adcab86fbD79df7a052034
export const DEBT_SWAP_ADAPTER = '0xE28E2c8d240dd5eBd0adcab86fbD79df7a052034';

// https://snowscan.xyz/address/0xaff73fD604d02b689989DfB5a2Da9d91E92B57D0
export const CONFIG_ENGINE = '0xaff73fD604d02b689989DfB5a2Da9d91E92B57D0';

// https://snowscan.xyz/address/0x770ef9f4fe897e59daCc474EF11238303F9552b6
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x770ef9f4fe897e59daCc474EF11238303F9552b6';

// https://snowscan.xyz/address/0xB94e515615c244Ab25f7A6e592e3Cb7EE31E99F4
export const PROOF_OF_RESERVE = '0xB94e515615c244Ab25f7A6e592e3Cb7EE31E99F4';

// https://snowscan.xyz/address/0x80f2c02224a2E548FC67c0bF705eBFA825dd5439
export const PROOF_OF_RESERVE_AGGREGATOR = '0x80f2c02224a2E548FC67c0bF705eBFA825dd5439';

// https://snowscan.xyz/address/0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16
export const REPAY_WITH_COLLATERAL_ADAPTER = '0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16';

// https://snowscan.xyz/address/0x691C316b2Eec7e64d17e7E3E01f3dB44c9CcEf19
export const LEGACY_STATIC_A_TOKEN_FACTORY = '0x691C316b2Eec7e64d17e7E3E01f3dB44c9CcEf19';

// https://snowscan.xyz/address/0x2Cf641F7C0eac2788A7924B82d6Ca8EB7bAa4E3A
export const SWAP_COLLATERAL_ADAPTER = '0x2Cf641F7C0eac2788A7924B82d6Ca8EB7bAa4E3A';

// https://snowscan.xyz/address/0x99732D5dA21f44f9e45e36eF9da4B1df2Eb0b28E
export const UI_INCENTIVE_DATA_PROVIDER = '0x99732D5dA21f44f9e45e36eF9da4B1df2Eb0b28E';

// https://snowscan.xyz/address/0x3518E8927A7827CDdAf841872453003CA95906A3
export const UI_POOL_DATA_PROVIDER = '0x3518E8927A7827CDdAf841872453003CA95906A3';

// https://snowscan.xyz/address/0xBc790382B3686abffE4be14A030A96aC6154023a
export const WALLET_BALANCE_PROVIDER = '0xBc790382B3686abffE4be14A030A96aC6154023a';

// https://snowscan.xyz/address/0x2825cE5921538d17cc15Ae00a8B24fF759C6CDaE
export const WETH_GATEWAY = '0x2825cE5921538d17cc15Ae00a8B24fF759C6CDaE';

// https://snowscan.xyz/address/0x78F8Bd884C3D738B74B420540659c82f392820e0
export const WITHDRAW_SWAP_ADAPTER = '0x78F8Bd884C3D738B74B420540659c82f392820e0';

// https://snowscan.xyz/address/0x0D5fA13Abca0bc06ac227eb4653cc5aDF4293341
export const DUST_BIN = '0x0D5fA13Abca0bc06ac227eb4653cc5aDF4293341';

// https://snowscan.xyz/address/0x6c2B732cB368322E460D718df3CD4F553d5fbAde
export const CLINIC_STEWARD = '0x6c2B732cB368322E460D718df3CD4F553d5fbAde';

// https://snowscan.xyz/address/0xC2E7A608d868817dd58438913Ed72955a0567561
export const STATA_FACTORY = '0xC2E7A608d868817dd58438913Ed72955a0567561';

// https://snowscan.xyz/address/0x0d68D50DB848dfE6012456781c1D79A11eD12a2e
export const POOL_EXPOSURE_STEWARD = '0x0d68D50DB848dfE6012456781c1D79A11eD12a2e';

export const CHAIN_ID = 43114;
export const ASSETS = {
  DAIe: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70',
    A_TOKEN: '0x82E64f49Ed5EC1bC6e43DAD4FC8Af9bb3A2312EE',
    V_TOKEN: '0x8619d80FB0141ba7F184CbF22fd724116D9f7ffC',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x0b47c51CCD4FaDe1D93C750bFCAB0a5ce8734ED0',
    STATIC_A_TOKEN: '0x02F3f6c8A432C1e49f3359d7d36887C25d8A5888',
    STATA_TOKEN: '0xC38aD3527A4B821BF437639cBA8Bf567BFa63A13',
  },
  LINKe: {
    decimals: 18,
    id: 1,
    UNDERLYING: '0x5947BB275c521040051D82396192181b413227A3',
    A_TOKEN: '0x191c10Aa4AF7C30e871E70C95dB0E4eb77237530',
    V_TOKEN: '0x953A573793604aF8d41F306FEb8274190dB4aE0e',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x49ccd9ca821EfEab2b98c60dC60F518E765EDe9a',
    STATIC_A_TOKEN: '0x8B773Ab77Dff01985D438961dBCE58382a70cA52',
    STATA_TOKEN: '0x61933AF56431280EE4e5667133D8aF6322D64B32',
  },
  USDC: {
    decimals: 6,
    id: 2,
    UNDERLYING: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
    A_TOKEN: '0x625E7708f30cA75bfd92586e17077590C60eb4cD',
    V_TOKEN: '0xFCCf3cAbbe80101232d343252614b6A3eE81C989',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0xb0D7A8bbDcdb1203850b742bB4d7f57a1F1C8483',
    STATIC_A_TOKEN: '0xC509aB7bB4eDbF193b82264D499a7Fc526Cd01F4',
    STATA_TOKEN: '0xe1bFC96d95BAdCB10Ff013Cb0C9C6c737ca07009',
  },
  WBTCe: {
    decimals: 8,
    id: 3,
    UNDERLYING: '0x50b7545627a5162F82A992c33b87aDc75187B218',
    A_TOKEN: '0x078f358208685046a11C85e8ad32895DED33A249',
    V_TOKEN: '0x92b42c66840C7AD907b4BF74879FF3eF7c529473',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x2779D32d5166BAaa2B2b658333bA7e6Ec0C65743',
    STATIC_A_TOKEN: '0xE3C0f42EAF1a4BFe37CbA105e5463564BA7730aE',
  },
  WETHe: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB',
    A_TOKEN: '0xe50fA9b3c56FfB159cB0FCA61F5c9D750e8128c8',
    V_TOKEN: '0x0c84331e39d6658Cd6e6b9ba04736cC4c4734351',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x976B3D034E162d8bD72D6b9C989d545b839003b0',
    STATIC_A_TOKEN: '0xf8E24175D01653fd6AA203C2C17B1e4Dd1CA2731',
    STATA_TOKEN: '0xdFD2b2437a94108323045C282fF1916de5Ac6Af7',
  },
  USDt: {
    decimals: 6,
    id: 5,
    UNDERLYING: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
    A_TOKEN: '0x6ab707Aca953eDAeFBc4fD23bA73294241490620',
    V_TOKEN: '0xfb00AC187a8Eb5AFAE4eACE434F493Eb62672df7',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x5b7810a910B4a878AaA4800a824E5E5796838009',
    STATIC_A_TOKEN: '0x5525Ee69BC1e354B356864187De486fab5AD67d7',
    STATA_TOKEN: '0x59933c571d200dc6A7Fd1CDa22495dB442082E34',
  },
  AAVEe: {
    decimals: 18,
    id: 6,
    UNDERLYING: '0x63a72806098Bd3D9520cC43356dD78afe5D386D9',
    A_TOKEN: '0xf329e36C7bF6E5E86ce2150875a84Ce77f477375',
    V_TOKEN: '0xE80761Ea617F66F96274eA5e8c37f03960ecC679',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x3CA13391E9fb38a75330fb28f8cc2eB3D9ceceED',
    STATIC_A_TOKEN: '0xac0746AfD13DEbe2a43a6c8745Fb83Fd2A2909cA',
    STATA_TOKEN: '0x7883978D1F322641a3AaA82Bac3b0a6Dee7A171E',
  },
  WAVAX: {
    decimals: 18,
    id: 7,
    UNDERLYING: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
    A_TOKEN: '0x6d80113e533a2C0fe82EaBD35f1875DcEA89Ea97',
    V_TOKEN: '0x4a1c3aD6Ed28a636ee1751C69071f6be75DEb8B8',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x0A77230d17318075983913bC2145DB16C7366156',
    STATIC_A_TOKEN: '0x6A02C7a974F1F13A67980C80F774eC1d2eD8f98d',
    STATA_TOKEN: '0xD7da0De6Ef4f51d6206bF2A35fCd2030F54c3F7B',
  },
  sAVAX: {
    decimals: 18,
    id: 8,
    UNDERLYING: '0x2b2C81e08f1Af8835a78Bb2A90AE924ACE0eA4bE',
    A_TOKEN: '0x513c7E3a9c69cA3e22550eF58AC1C0088e918FFf',
    V_TOKEN: '0x77CA01483f379E58174739308945f044e1a764dc',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0xB2B332f27e4B7305649a228C31Ed9858c5a6bAD9',
    STATIC_A_TOKEN: '0x4F059cA8a2a5BF8895Ee731f2E901cCB769FB95f',
    STATA_TOKEN: '0x7D0394F8898fBA73836Bf12bD606228887705895',
  },
  FRAX: {
    decimals: 18,
    id: 9,
    UNDERLYING: '0xD24C2Ad096400B6FBcd2ad8B24E7acBc21A1da64',
    A_TOKEN: '0xc45A479877e1e9Dfe9FcD4056c699575a1045dAA',
    V_TOKEN: '0x34e2eD44EF7466D5f9E0b782B5c08b57475e7907',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x0b7c356de5E68A8A257fcD23Ac1e8204D753A6fb',
    STATIC_A_TOKEN: '0xA3c2ffE702F4cD265B2249AB5f84Fab81FFf6c73',
    STATA_TOKEN: '0x3929336Afd0BBa6FCAbB67dFB78610379C66B43B',
  },
  MAI: {
    decimals: 18,
    id: 10,
    UNDERLYING: '0x5c49b268c9841AFF1Cc3B0a418ff5c3442eE3F3b',
    A_TOKEN: '0x8Eb270e296023E9D92081fdF967dDd7878724424',
    V_TOKEN: '0xCE186F6Cccb0c955445bb9d10C59caE488Fea559',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x85142981C14D98a4B69B04225ca74b764648D443',
    STATIC_A_TOKEN: '0x08cC59E51BB0Bc322B4D251f7262dB864d6150ce',
  },
  BTCb: {
    decimals: 8,
    id: 11,
    UNDERLYING: '0x152b9d0FdC40C096757F570A51E494bd4b943E50',
    A_TOKEN: '0x8ffDf2DE812095b1D19CB146E4c004587C0A0692',
    V_TOKEN: '0xA8669021776Bc142DfcA87c21b4A52595bCbB40a',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x2779D32d5166BAaa2B2b658333bA7e6Ec0C65743',
    STATIC_A_TOKEN: '0x34d768cc830c32DcD743321c09A2A702651bF9a2',
    STATA_TOKEN: '0x2d324fD1Ca86D90f61B0965d2db2f86d22eA4B74',
  },
  AUSD: {
    decimals: 6,
    id: 12,
    UNDERLYING: '0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a',
    A_TOKEN: '0x724dc807b04555b71ed48a6896b6F41593b8C637',
    V_TOKEN: '0xDC1fad70953Bb3918592b6fCc374fe05F5811B6a',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x83f32c0882B12Ef16214c417efF11FD9e764bf34',
    STATA_TOKEN: '0x45cf39EeB437FA95Bb9b52c0105254a6BD25D01e',
  },
  GHO: {
    decimals: 18,
    id: 13,
    UNDERLYING: '0xfc421aD3C883Bf9E7C4f42dE845C4e4405799e73',
    A_TOKEN: '0xf611aEb5013fD2c0511c9CD55c7dc5C1140741A6',
    V_TOKEN: '0x38d693cE1dF5AaDF7bC62595A37D667aD57922e5',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x360d8aa8F6b09B7BC57aF34db2Eb84dD87bf4d12',
    STATA_TOKEN: '0x79459f4C9AfC902488109D058C3E76ed0B037c41',
  },
  EURC: {
    decimals: 6,
    id: 14,
    UNDERLYING: '0xC891EB4cbdEFf6e073e859e987815Ed1505c2ACD',
    A_TOKEN: '0x8a9FdE6925a839F6B1932d16B36aC026F8d3FbdB',
    V_TOKEN: '0x5D557B07776D12967914379C71a1310e917C7555',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x3368310bC4AeE5D96486A73bae8E6b49FcDE62D3',
  },
  USDe: {
    decimals: 18,
    id: 15,
    UNDERLYING: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
    A_TOKEN: '0x6533afac2E7BCCB20dca161449A13A32D391fb00',
    V_TOKEN: '0x6B4b37618D85Db2a7b469983C888040F7F05Ea3D',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x5b7810a910B4a878AaA4800a824E5E5796838009',
  },
  sUSDe: {
    decimals: 18,
    id: 16,
    UNDERLYING: '0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2',
    A_TOKEN: '0x44705f578135cC5d703b4c9c122528C73Eb87145',
    V_TOKEN: '0x8437d7C167dFB82ED4Cb79CD44B7a32A1dd95c77',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0x8Fb2db0A3b25db76B9BE2013751F8390ea8E5f0A',
  },
  wrsETH: {
    decimals: 18,
    id: 17,
    UNDERLYING: '0x7bFd4CA2a6Cf3A3fDDd645D10B323031afe47FF0',
    A_TOKEN: '0x40B4BAEcc69B882e8804f9286b12228C27F8c9BF',
    V_TOKEN: '0x3ca5FA07689F266e907439aFd1fBB59c44fe12f6',
    INTEREST_RATE_STRATEGY: '0xCe1C5509f2f4d755aA64B8D135B15ec6F12a93da',
    ORACLE: '0xe5Af98d1c62c7D9C1378AF187eEFB0BEe112ff64',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'DAIe,USDC,USDt,FRAX,MAI / ',
    collateralBitmap: '1573',
    collateralAssets: [
      '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70',
      '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
      '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
      '0xD24C2Ad096400B6FBcd2ad8B24E7acBc21A1da64',
      '0x5c49b268c9841AFF1Cc3B0a418ff5c3442eE3F3b',
    ],
    borrowableBitmap: '0',
    borrowableAssets: [],
    ltvzeroBitmap: '1537',
    ltvzeroAssets: [
      '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70',
      '0xD24C2Ad096400B6FBcd2ad8B24E7acBc21A1da64',
      '0x5c49b268c9841AFF1Cc3B0a418ff5c3442eE3F3b',
    ],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '2': {
    label: 'WAVAX,sAVAX / WAVAX',
    collateralBitmap: '384',
    collateralAssets: [
      '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
      '0x2b2C81e08f1Af8835a78Bb2A90AE924ACE0eA4bE',
    ],
    borrowableBitmap: '128',
    borrowableAssets: ['0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '3': {
    label: 'USDe / USDC,USDt,GHO',
    collateralBitmap: '32768',
    collateralAssets: ['0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34'],
    borrowableBitmap: '8228',
    borrowableAssets: [
      '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
      '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
      '0xfc421aD3C883Bf9E7C4f42dE845C4e4405799e73',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8900,
    liquidationThreshold: 9200,
    liquidationBonus: 10200,
  },
  '4': {
    label: 'sUSDe / USDC,USDt,GHO,USDe',
    collateralBitmap: '65536',
    collateralAssets: ['0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2'],
    borrowableBitmap: '40996',
    borrowableAssets: [
      '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
      '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
      '0xfc421aD3C883Bf9E7C4f42dE845C4e4405799e73',
      '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8900,
    liquidationThreshold: 9100,
    liquidationBonus: 10400,
  },
  '5': {
    label: 'wrsETH / WETHe',
    collateralBitmap: '131072',
    collateralAssets: ['0x7bFd4CA2a6Cf3A3fDDd645D10B323031afe47FF0'],
    borrowableBitmap: '16',
    borrowableAssets: ['0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
